import PropTypes from "prop-types";
import { Card, Row, Col } from "react-bootstrap";

const BodyMetrics = ({ height, weight, bmi }) => {
  return (
    <Card className="body-metrics-card mb-0">
      <Row className="text-center">
        <Col className="metric-col">
          <div className="metric-label">Height</div>
          <div className="metric-value text-color-for-mhc">{height ? `${height} m` : "--"}</div>
        </Col>
        <Col className="metric-col border-col">
          <div className="metric-label">Weight</div>
          <div className="metric-value text-color-for-mhc">{weight ? `${weight} kg` : "--"}</div>
        </Col>
        <Col className="metric-col">
          <div className="metric-label">BMI</div>
          <div className="metric-value text-color-for-mhc">
            {bmi=== null ? "--" : `${bmi} kg/m²`}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

BodyMetrics.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bmi: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BodyMetrics;
